export const sanitizeFileName = (input) => {
    // Split the name and extension
    const lastDotIndex = input.lastIndexOf(".");
    const hasExtension = lastDotIndex > 0 && lastDotIndex < input.length - 1;
    const namePart = hasExtension ? input.slice(0, lastDotIndex) : input;
    const extPart = hasExtension ? input.slice(lastDotIndex + 1) : "";
    // Clean the name part: remove all except alphanumerics, underscores, hyphens and spaces
    const cleanedName = namePart
        .replace(/[^\w\s-]+/g, "") // Remove disallowed characters
        .replace(/\s+/g, "-") // Replace whitespace with hyphens
        .toLowerCase();
    // Clean the extension: remove any dangerous characters (paranoia-safe)
    const cleanedExt = extPart.replace(/[^\w]+/g, "").toLowerCase();
    return cleanedExt ? `${cleanedName}.${cleanedExt}` : cleanedName;
};
export default sanitizeFileName;
